module.exports = __webpack_public_path__ + "img/ceo_way_tip_01.a60a2765.png";